import * as constants from './constants';

export function setGeoLocationValue(data) {
  return { type: constants.SET_GEO_LOCATION_VALUE, payload: data };
}
